// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Result_scroll-black__PVixc","title":"Result_title__h6kYT","wrapper":"Result_wrapper__OUbQt","actions":"Result_actions__xoeH_"};